import * as yup from "yup"
import type { User } from "../../types"

export function initialValuesUtente(utente?: User | undefined) {
  if (utente) {
    return utente
  }
  return {
    full_name: "",
    email: "",
  }
}

export function validationSchemaUtente() {
  return yup.object().shape({
    full_name: yup.string().required("Campo obbligatorio"),
    email: yup.string().email("Email non valida").required("Campo obbligatorio"),
  })
}
